import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { OfficeService } from "../../api/services/office.service";
import { OfficeNameDto } from "../../api/models/office-name-dto";

@Injectable({
  providedIn: "root",
})
export class OfficesResolver implements Resolve<Array<OfficeNameDto>> {
  constructor(private officesService: OfficeService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Array<OfficeNameDto>> {
    return this.officesService.officeControllerFindAllDropdown({ initial: false });
  }
}
